/*global
    jQuery, aap, Awesomplete
*/
(function ($) {

    'use strict';

    var $zip = $('#zip'),
        $sZip = $('#shelter_zip'),
        $shelterForm = $('#shelter_rescue_selection');

    var prePopulateCityState = function() {

        var $field = $(this),
            fieldValue = this.value,
            url = aap.stringformat('{0}?zipcode={1}', $field.data('url'), fieldValue),
            fillCityState = function(data) {
                //ajax success
                var matches = data.matches,
                    template = '{0}, {1}',
                    cityState = document.getElementById('city_state');

                if (matches.length > 0) {
                    //there are more than 1 matches so create the list for awesomplete
                    var list = [],
                        awesomplete = new Awesomplete(cityState);
                    for (var i = 0, l = matches.length; i < l; i++) {
                        list.push(aap.stringformat(template, matches[i].city, matches[i].state));
                    }
                    //assign list to awesomplete
                    awesomplete.list = list;
                }

                //populate with first match
                cityState.value = aap.stringformat(template, matches[0].city, matches[0].state);
                $(cityState).focus();

            },
            showError = function()  {
                //ajax failed
                var $error = $field.next(),
                    $great = $field.siblings('.great');

                $error.text('Invalid');
                $field.removeClass('valid').addClass('error');
                $great.text('Oops!').removeClass('valid-flag').addClass('error-flag');
            };

        if (!aap.is(fieldValue).empty()) {
            //ajax
            $.get(url).done(fillCityState).fail(showError);
        }

    };

    var shelterAutocomplete = function() {
        var $this = $(this),
            location = $this.val();

        if(typeof location !== 'undefined' && isNaN(parseInt(location))) {
            location = location.split(', ');
            if (location.length === 1) {
                return false;
            } else {
                location = aap.stringformat('{0}/{1}', location[0], location[1].toUpperCase());
            }
        }

        var url = $this.data('url') + '/' + location,
            elSelect = $('#donation_shelter_rescue'),
            list = [],
            populate = function (data) {
                var shelters = data.shelters,
                    $dummy = $('#dummy_shelter');

                $('.errors').empty().hide();
                $this.removeClass('error');

                list = shelters.map(function (item) {
                    return {label: item.shelter_name, value: item.shelter_id};
                });

                console.log(url);

                $dummy.attr('placeholder', 'Choose from List');
                var auto = new Awesomplete(('#dummy_shelter'),{
                    autoFirst: true,
                    replace: function (suggestion) {
                        console.log(suggestion);
                        this.input.value = suggestion.label;
                        elSelect.val( suggestion.value + '-' + suggestion.label );
                    }
                });
                auto.list = list;


                Awesomplete.$('#dummy_shelter').addEventListener('focus', function() {
                    if (auto.ul.childNodes.length === 0) {
                        auto.minChars = 0;
                        auto.evaluate();
                    }
                    else if (auto.ul.hasAttribute('hidden')) {
                        auto.open();
                    }
                    else {
                        auto.close();
                    }
                });
            },
            reportError = function(){
                var message = '<li>Location should be a valid zip code or city state, eg: Claremont, CA</li>';
                $this.addClass('error');
                $('.errors').html(message).show();
            };

        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json',
            headers:{
                'X-CSRF-TOKEN': $('#shelter_rescue_selection').find('input[name="_token"]').val()
            }
        }).done(populate).fail(reportError);

    };


    function validateForm(e) {
        e.preventDefault();
        var $terms = $('#terms_and_conditions'),
            $noReferral = $('#no_referral'),
            $shelter = $('#dummy_shelter'),
            $shelterZip = $('#shelter_zip'),
            isValid = true,
            errors = [],
            shelterMsg = '';

        if(!$terms.is(':checked')) {
            isValid = false;
            errors.push('You must agree to terms');
            $terms.addClass('error');
        }

        if(!$noReferral.is(':checked') && !$shelter.val()) {
            isValid = false;
            shelterMsg = 'Please tell us if a shelter/rescue referred you. ';
            shelterMsg += 'If you were not referred by shelter/rescue, please ';
            shelterMsg += 'check the checkbox near the bottom of the page.';
            errors.push(shelterMsg);
            $shelterZip.addClass('error');
        }

        if(!isValid) {
            var ml = [],
                tmpl = '<li>{0}</li>';

            errors.forEach(function(val) {
                ml.push(aap.stringformat(tmpl, val));
            });

            $('.errors').html(ml.join('')).show();
        }

        if(isValid) {
            $shelterForm.off().trigger('submit');
        }
    }

    $shelterForm.on('submit', validateForm);
    $zip.on('blur', prePopulateCityState);
    $sZip.on('blur', shelterAutocomplete);
}(jQuery));
